import { render, staticRenderFns } from "./QuizAnswer.vue?vue&type=template&id=f53e86be&scoped=true&"
import script from "./QuizAnswer.vue?vue&type=script&lang=js&"
export * from "./QuizAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuizAnswer.vue?vue&type=style&index=0&id=f53e86be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53e86be",
  null
  
)

export default component.exports